import { PaginatedData } from "../hooks/PaginationHooks";
import { AnalysisFile, AnalysisFileType } from "../types/analysisFileTypes";
import { CompanyInvoiceFile } from "../types/invoiceTypes";
import { PaginationParameters, toQueryParameters } from "./Pagination";
import { doApiGet } from "./Requests";

export const superAdminBillsApi = {
  getSuperAdminAnalysisFilesByFileType: (pagination: PaginationParameters, fileType: AnalysisFileType) =>
    doApiGet<PaginatedData<AnalysisFile>>(`/api/administratorusers/analysisfiles?${toQueryParameters(pagination)}&fileType=${fileType}`),

  getSuperAdminInvoices: (pagination: PaginationParameters) =>
    doApiGet<PaginatedData<CompanyInvoiceFile>>(`/api/administratorusers/invoices?${toQueryParameters(pagination)}`),
};
